/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Fatura_GereksinimlerInputs */

const tr_faq_q_fatura_gereksinimler = /** @type {(inputs: Faq_Q_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e-Fatura kesmek için ne gerekli?`)
};

const en_faq_q_fatura_gereksinimler = /** @type {(inputs: Faq_Q_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do I need to issue e-invoices?`)
};

const de_faq_q_fatura_gereksinimler = /** @type {(inputs: Faq_Q_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was brauche ich für e-Rechnungen?`)
};

const ru_faq_q_fatura_gereksinimler = /** @type {(inputs: Faq_Q_Fatura_GereksinimlerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что нужно для выставления счетов?`)
};

/**
* | output |
* | --- |
* | "What do I need to issue e-invoices?" |
*
* @param {Faq_Q_Fatura_GereksinimlerInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_fatura_gereksinimler = /** @type {((inputs?: Faq_Q_Fatura_GereksinimlerInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Fatura_GereksinimlerInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_fatura_gereksinimler(inputs)
	if (locale === "de") return de_faq_q_fatura_gereksinimler(inputs)
	if (locale === "ru") return ru_faq_q_fatura_gereksinimler(inputs)
	return tr_faq_q_fatura_gereksinimler(inputs)
});